import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from './inbox';

const isBrowserWhatsappInbox = inbox =>
  inbox?.channel_type === INBOX_TYPES.WHATSAPP_BROWSER ||
  (inbox?.channel_type === INBOX_TYPES.API &&
    inbox?.provider === 'waha_browser_whatsapp');

const isWhatsAppCloudEmbeddedSignup = inbox =>
  inbox?.channel_type === INBOX_TYPES.WHATSAPP &&
  inbox?.provider === 'whatsapp_cloud' &&
  inbox?.provider_config?.source === 'embedded_signup';

const isWhatsAppCloudManualWebhook = inbox =>
  inbox?.channel_type === INBOX_TYPES.WHATSAPP &&
  inbox?.provider === 'whatsapp_cloud' &&
  inbox?.provider_config?.source !== 'embedded_signup';

const is360DialogWhatsApp = inbox =>
  inbox?.channel_type === INBOX_TYPES.WHATSAPP && inbox?.provider === 'default';

const isTwilioWhatsApp = inbox =>
  inbox?.channel_type === INBOX_TYPES.TWILIO &&
  inbox?.medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP;

const isTwilioSms = inbox =>
  inbox?.channel_type === INBOX_TYPES.TWILIO &&
  inbox?.medium === TWILIO_CHANNEL_MEDIUM.SMS;

/**
 * Returns i18n step suffixes under INBOX_MGMT.TROUBLESHOOT.STEPS (e.g. "WEB.1").
 * The contact step is appended separately in the UI.
 */
export const getInboxTroubleshootStepKeys = inbox => {
  if (!inbox?.channel_type) return ['GENERIC.1', 'GENERIC.2'];

  if (isBrowserWhatsappInbox(inbox)) {
    return ['WHATSAPP_BROWSER.1', 'WHATSAPP_BROWSER.2', 'WHATSAPP_BROWSER.3'];
  }

  switch (inbox.channel_type) {
    case INBOX_TYPES.WEB:
      return ['WEB.1', 'WEB.2', 'WEB.3'];
    case INBOX_TYPES.FB:
      return ['FB.1', 'FB.2', 'FB.3'];
    case INBOX_TYPES.INSTAGRAM:
      return ['INSTAGRAM.1', 'INSTAGRAM.2', 'INSTAGRAM.3'];
    case INBOX_TYPES.WHATSAPP:
      if (isWhatsAppCloudEmbeddedSignup(inbox)) {
        return [
          'WHATSAPP_EMBEDDED.1',
          'WHATSAPP_EMBEDDED.2',
          'WHATSAPP_EMBEDDED.3',
        ];
      }
      if (isWhatsAppCloudManualWebhook(inbox)) {
        return [
          'WHATSAPP_WEBHOOK.1',
          'WHATSAPP_WEBHOOK.2',
          'WHATSAPP_WEBHOOK.3',
        ];
      }
      if (is360DialogWhatsApp(inbox)) {
        return ['WHATSAPP_360.1', 'WHATSAPP_360.2', 'WHATSAPP_360.3'];
      }
      return ['WHATSAPP.1', 'WHATSAPP.2', 'WHATSAPP.3'];
    case INBOX_TYPES.TWILIO:
      if (isTwilioWhatsApp(inbox)) {
        return ['TWILIO_WHATSAPP.1', 'TWILIO_WHATSAPP.2', 'TWILIO_WHATSAPP.3'];
      }
      if (isTwilioSms(inbox)) {
        return ['TWILIO_SMS.1', 'TWILIO_SMS.2', 'TWILIO_SMS.3'];
      }
      return ['TWILIO.1', 'TWILIO.2', 'TWILIO.3'];
    case INBOX_TYPES.SMS:
      return ['SMS.1', 'SMS.2', 'SMS.3'];
    case INBOX_TYPES.EMAIL:
      return ['EMAIL.1', 'EMAIL.2', 'EMAIL.3'];
    case INBOX_TYPES.API:
      return ['API.1', 'API.2', 'API.3'];
    case INBOX_TYPES.TELEGRAM:
      return ['TELEGRAM.1', 'TELEGRAM.2', 'TELEGRAM.3'];
    case INBOX_TYPES.LINE:
      return ['LINE.1', 'LINE.2', 'LINE.3'];
    case INBOX_TYPES.TWITTER:
      return ['TWITTER.1', 'TWITTER.2', 'TWITTER.3'];
    case INBOX_TYPES.TIKTOK:
      return ['TIKTOK.1', 'TIKTOK.2', 'TIKTOK.3'];
    case INBOX_TYPES.VOICE:
      return ['VOICE.1', 'VOICE.2', 'VOICE.3'];
    default:
      return ['GENERIC.1', 'GENERIC.2', 'GENERIC.3'];
  }
};

export const getContactPageUrl = hostURL => {
  const base = (hostURL || window.chatwootConfig?.hostURL || '').replace(
    /\/$/,
    ''
  );
  return `${base}/contact`;
};
